const items = [];
const shoppingCartItems = [];
window.addEventListener(
  'message',
  (event) => {
    if (event.data && event.data.eventName === 'addShoppigCartItem') {
      shoppingCartItems.push({ vendor_code: event.data.payload.item.vendor_code });

        // event.data.payload.item.vendor_code is the product sku, lets get the product ID from shopify


        // window.variantLookup

        // Create payload for Shopify cart API
        const payload = {
            items: [{
                id: window.variantLookup[event.data.payload.item.vendor_code],
                quantity: 1
            }]
        };

        // Make AJAX request to Shopify cart API
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(data => {
            // console.log('Product added to cart:', data);
            $('.back-button--desktop').click();
            $('.openCartDrawer').click();
        })
        .catch(error => {
            console.error('Error adding product to cart:', error);
        });
        

      // console.log('addShoppigCartItem', { shoppingCartItems });
      window.postMessage(
        {
          eventName: 'setShoppingCartStore',
          payload: shoppingCartItems,
        },
        '*',
      );
    }
    if (event.data && event.data.eventName === 'removeShoppigCartItem') {

        
      // Event handling
      const foundIndex = shoppingCartItems.findIndex(
        (item) => item.vendor_code === event.data.payload.item.vendor_code,
      );
      if (foundIndex !== -1) {
        shoppingCartItems.splice(foundIndex, 1);
        window.postMessage(
          {
            eventName: 'setShoppingCartStore',
            payload: shoppingCartItems,
          },
          '*',
        );
      }
      // console.log('removeShoppigCartItem', { shoppingCartItems });
    }
  },
  false,
);